// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___YpaUf","filtersContainer":"filtersContainer___gkqgC","productTitle":"productTitle___FGEtt"};